var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-background-image",class:{
        'u-height-100': _vm.$vuetify.breakpoint.mdAndUp,
    }},[_c('BaseImage',{staticClass:"gst-background-image__picture u-height-100",attrs:{"src":_vm.src,"transition":"fade-transition","cover":""}}),_c('div',{staticClass:"gst-background-image__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }